export default __webpack_public_path__ + "static/media/move_icon_bold.1526b0f3.svg";